import {
  getFlightSearchForAdd,
  getFlightSearchForUpdate,
  getVendorSearchForAdd,
  getVendorSearchForUpdate,
} from "app/services/vendorService";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";

export default function CarrierSingleSearch({
  setSelected,
  selected,
  type,
  setFieldValue,
  touched,
  errors,
  edit,
  userGroupId,
  value,
}) {
  const [allFlight, setAllFlight] = useState([]);
  const loadOptions = async (inputValue) => {
    if (!inputValue) return [];

    const updateReq = inputValue
      ? `?searchText=${inputValue}&UserGroupId=${userGroupId}`
      : "";
    // if (type === "vendor") {
    //   const response =
    //     edit == false
    //       ? await getVendorSearchForAdd(inputValue)
    //       : await getVendorSearchForUpdate(updateReq);
    //   const vendors = response.data.data || [];
    //   return vendors.map((vendor) => ({
    //     label: vendor.supplierName,
    //     value: vendor.id,
    //   }));
    // } else {
    const response =
      edit == false
        ? await getFlightSearchForAdd(inputValue)
        : await getFlightSearchForUpdate(updateReq);

    const flights = response.data.data || [];
    return flights.map((flight) => ({
      label: flight.carrierName,
      value: flight.id,
    }));
    // }
  };

  const handleChange = (selectedOption) => {
    setSelected(selectedOption);
    setFieldValue("carrierId", selectedOption ? selectedOption.value : 0);
    // if (type === "vendor") {
    //   setFieldValue("supplierId", selectedOption ? selectedOption.value : 0);
    // } else {
    //   // debugger;
    //   setFieldValue(
    //     "carrierIdList",
    //     selectedOption ? selectedOption.map((opt) => opt.value) : []
    //   );
    // }
  };
  useEffect(() => {
    const fetchSearch = async () => {
      const { data } = await getFlightSearchForAdd(""); // Fetch all countries at once
      if (data?.data?.length > 0) {
        setAllFlight(data.data);
      }
    };

    fetchSearch(); // Call API only once
  }, []);
  useEffect(() => {
    if (value && allFlight.length > 0) {
      const selected = allFlight.find((item) => item.id == value);
      if (selected) {
        setSelected({
          label: selected.carrierName,
          value: selected.id,
        });
        setFieldValue("supplierId", selected ? selected.id : 0);
      }
    }
  }, [value, allFlight]);
  return (
    <div>
      <AsyncSelect
        // isMulti={type !== "vendor"}
        cacheOptions
        defaultOptions
        value={selected}
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder={"Select Carrier..."}
        name={"carrierId"}
      />
      {touched.carrierId && errors.carrierId && (
        <div className="text-danger">{errors.carrierId}</div>
      )}
    </div>
  );
}
